import {
  CustomizationIngredientsGridContainer,
  CustomizationIngredientsGridNav,
  CustomizationIngredientsGridNavItem,
  CustomizationIngredientsGridNavItemCustom,
  CustomizationIngredientsGridSection,
  CustomizationIngredientsGridSectionHeading,
  CustomizationIngredientsGridSectionStack,
} from './components';

export const CustomizationIngredientsGrid = {
  Nav: CustomizationIngredientsGridNav,
  NavItem: CustomizationIngredientsGridNavItem,
  NavItemCustom: CustomizationIngredientsGridNavItemCustom,
  Container: CustomizationIngredientsGridContainer,
  Section: CustomizationIngredientsGridSection,
  SectionHeading: CustomizationIngredientsGridSectionHeading,
  SectionStack: CustomizationIngredientsGridSectionStack,
};
